import { useMemo } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { LayerTypeSelectionHeaderProps } from "../../types";
import { usePlanningAppById } from "./usePlanningAppsById";
import { feature } from "@turf/helpers";
import clsx from "clsx";

export function PlanningApplicationSelectionHeader({ selection, onHeaderClick }: LayerTypeSelectionHeaderProps) {
  const { t } = useTranslation();
  const [data, loading] = usePlanningAppById(selection?.id);

  const handleHeaderClick = useMemo(() => {
    if (!onHeaderClick) return;

    const planningGeometry = data?.boundary || data?.location;

    if (!planningGeometry) return;

    return () => onHeaderClick({ ...selection, feature: feature(planningGeometry) });
  }, [data, onHeaderClick, selection]);

  if (loading)
    return (
      <div className="relative h-10" data-testid="designation-header-loading">
        <SkeletonLoading rows={1} showPadding={false} />
      </div>
    );

  return (
    <div key={selection?.id} className="flex flex-col items-start">
      <div className="flex flex-col items-stretch grow">
        <div className="text-xs font-semibold uppercase text-text-base-tertiary">
          {t("planning.planning_application_list.header")}
        </div>

        <div
          onClick={handleHeaderClick}
          className={clsx("text-sm font-semibold", {
            "cursor-pointer text-platform-blue-600 hover:text-platform-blue-700": handleHeaderClick,
            "text-text-base-primary": !handleHeaderClick,
          })}
        >
          {data.ref}
        </div>
      </div>
    </div>
  );
}
